import { Container, Paper, styled, Typography, TextField } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import BalanceCard from 'components/BalanceCard';
import ZizziPoint from 'assets/icons/ZizziPoint';
import { InfoRounded } from '@mui/icons-material';

const pageBgColor = theme.palette.white;

export const StyledContainer = styled(Container)`
  ${theme.breakpoints.up('md')} {
    margin: 3rem auto 1rem;
    max-width: 880px;
  }
`;

export const Title = styled(Typography)`
  padding: 1rem;
  margin: 0;

  ${theme.breakpoints.up('md')} {
    padding-top: 2.5rem;
  }
`;

export const StyledPaper = styled(Paper)`
  border-radius: ${theme.radius?.lg};
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Hero = styled('div')`
  position: relative;
`;

export const StyledBalanceCard = styled(BalanceCard)`
  margin-bottom: -25px;
  position: relative;
  width: 90%;
  z-index: 1;
`;

export const StyledTextField = styled(TextField)`
  input {
    padding-top: 8px;
    height: 40px;
  }
`;

export const Footer = styled('div')`
  align-items: center;
  background: ${pageBgColor};
  border-radius: ${theme.radius?.lg} ${theme.radius?.lg} 0 0;
  box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: auto;
  padding: 1rem;
  position: relative;

  ${theme.breakpoints.up('sm')} {
    border-radius: ${theme.radius?.lg};
  }
`;

export const Image = styled('img')`
  width: 100%;
`;

export const StyledBox = styled('div')`
  padding: 1rem;

  & + & {
    padding-top: 0;
  }
`;

export const Amount = styled('span')`
  font-family: 'Zizzi';
  font-size: 1rem;
`;

export const StyledLogo = styled(ZizziPoint)`
  height: 20px;
  width: 20px;
  margin-bottom: -5px;

  ${theme.breakpoints.up('sm')} {
    height: 25px;
    width: 25px;
    margin-bottom: -7px;
  }
`;

export const StyledInfoRounded = styled(InfoRounded)`
  height: 20px;
  width: 20px;
  margin-bottom: -5px;
  margin-left: 4px;

  ${theme.breakpoints.up('sm')} {
    height: 25px;
    width: 25px;
    margin-bottom: -7px;
  }
`;
